import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { DocumentRecogniserRequestRegistrationForm } from './models';

export type RegisterDocumentRecogniserRequestTrigger = ReturnType<
  typeof useRegisterDocumentRecogniserRequestMutation
>[0];

export const documentRecogniserApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'hl-ai-doc-recogniser-api',
  endpoints: (build) => ({
    registerDocumentRecogniserRequest: build.mutation<
      void,
      DocumentRecogniserRequestRegistrationForm
    >({
      query: (data) => ({
        url: `/secured/document-recogniser/register-request`,
        method: 'POST',
        data
      })
    })
  })
});

export const { useRegisterDocumentRecogniserRequestMutation } =
  documentRecogniserApi;
